// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lazyImg[data-v-7ae1bb19]{position:relative}.lazyImg[data-v-7ae1bb19],.lazyImg__item[data-v-7ae1bb19],.lazyImg__slot[data-v-7ae1bb19]{width:inherit;height:inherit;border-radius:inherit}.lazyImg__slot[data-v-7ae1bb19]{top:50%;left:50%;transform:translate(-50%,-50%);position:absolute}.lazyImg__slot .skeleton[data-v-7ae1bb19]{width:100%;height:100%;border-radius:inherit}.hide[data-v-7ae1bb19]{visibility:hidden}.contain[data-v-7ae1bb19]{-o-object-fit:contain;object-fit:contain}", ""]);
// Exports
module.exports = exports;
